import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增银行卡")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("支付比例")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消支付比例")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, computed, onActivated } from 'vue'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 获取-个人银行卡列表
  'GET/users/bank_cards/personal': fetchList,
  // 新增-个人银行卡
  'POST/users/bank_cards': usersBank_cardsAddApi,
  // 修改-个人银行卡
  'PATCH/users/bank_cards': usersBank_cardsModifyApi,
  // 单个删除-个人银行卡
  'DELETE/users/bank_cards/{id}': bank_cardsDelApi,
  // 获取-银行列表
  'POST/banks/list': bankListApi,
  // 批量确认-个人银行卡
  'PATCH/users/bank_cards/batch': batchConfirmApi,
  // 关闭和开始银行卡
  'PATCH/users/bank_cards/convert': convertApi,
  // 银行卡比例设置
  'PATCH/users/bank_cards/setRatio': setRatioApi,
} = Api

const store = useStore()
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
onActivated(() => {
  fetchData(MI_params)
})
// 添加
let addCardEle = ref()
let addConfig: any = ref([
  {
    type: 'SELECT',
    label: '银行简称',
    value: '',
    upKey: 'bankId',
    selectFunc: bankListApi,
    options: [],
    rule: [{ required: true, message: '请选择银行', trigger: 'change' }],
    props: { clearable: true, placeholder: '请选择银行', },
    seleProps: { 
      label: 'alias',
      valueName: 'id',
    }
  },
  {
    label: '银行卡号',
    value: '',
    upKey: 'account',
    rule: [{ required: true, message: '请输入银行卡号', trigger: 'change' }],
    props: { 
      clearable: true, 
      placeholder: '请输入银行卡号',
      formatter: (value: string) => value.replace(/(\d{4})(?=\d)/g, '$1 '),
      // parser: (value: string) => value.replace(/\s+/g, '')
    },
  },
  {
    label: '开户行信息',
    value: '',
    upKey: 'location',
    props: {clearable: true, placeholder: '请输入开户行信息'},
  },
  {
    type: 'SELECT',
    label: '卡用途',
    value: '',
    upKey: 'purpose',
    rule: [{ required: true, message: '请选择卡用途', trigger: 'change' }],
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '奖金卡', id: '奖金卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡用途'},
    seleProps: {},
    selectCb: (value: string) => {
      if(value !== '尽孝金卡'){
        addCardEle.value.dataObj.name = ''
        addConfig.value[4].rule[0].required = false
        addConfig.value[4].props.disabled = true
      } else {
        addConfig.value[4].rule[0].required = true
        addConfig.value[4].props.disabled = false
      }
    }
  },
  {
    label: "持卡人姓名",
    value: '',
    upKey: 'name',
    rule: [{ required: false, message: '请输入持卡人姓名', trigger: 'change' }],
    props: { clearable : true, disabled: true }
  },

])
// 判断是否是尽孝金卡

const addFg = ref<boolean>(false)
const addCardHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    // 如果没有填写支行，弹框提示
    if(!params.location){
      await ElMessageBox.confirm(
        '开户行信息在银行APP里面可以查到。若未填写，可能银行付款会退回。',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
    }

    await usersBank_cardsAddApi({
      ...params,
      userId: store.getters.userId,
      name: params.purpose === '尽孝金卡' ? params.name : '',
      account: params.account.replace(/\s+/g, '')
    })
    ElMessage.success('添加成功')
    addFg.value = false
    fetchData(MI_params)
  })
}



// 确认前修改
let modifyCardEle = ref()
const modifyFg = ref<boolean>(false)
const modifyConfig = ref([
  {
    type: 'SELECT',
    label: '银行',
    value: '',
    upKey: 'bankId',
    selectFunc: bankListApi,
    options: [],
    rule: [{ required: true, message: '请选择银行', trigger: 'change' }],
    props: { clearable: true, placeholder: '请选择银行', },
    seleProps: { 
      label: 'alias',
      valueName: 'id',
    }
  },
  {
    label: '银行卡号',
    value: '',
    upKey: 'account',
    rule: [{ required: true, message: '请输入银行卡号', trigger: 'change' }],
    props: {type: 'number', clearable: true, placeholder: '请输入银行卡号'},
  },
  {
    label: '开户行信息',
    value: '',
    upKey: 'location',
    rule: [{ required: true, message: '请输入开户行信息', trigger: 'change' }],
    props: {clearable: true, placeholder: '请输入开户行信息'},
  },
  {
    type: 'SELECT',
    label: '卡用途',
    value: '',
    upKey: 'purpose',
    rule: [{ required: true, message: '请选择卡用途', trigger: 'change' }],
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '奖金卡', id: '奖金卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡用途'},
    seleProps: {},
    selectCb: (value: string) => {
      if(value !== '尽孝金卡'){
        modifyCardEle.value.dataObj.name = ''
        modifyConfig.value[4].rule[0].required = false
        modifyConfig.value[4].props.disabled = true
      } else {
        // 如果修改前是尽孝金卡
        if(currentModifyRow.purpose === '尽孝金卡'){
          modifyCardEle.value.dataObj.name = currentModifyRow.name
        } else {
          modifyCardEle.value.dataObj.name = ''
        }
        modifyConfig.value[4].rule[0].required = true
        modifyConfig.value[4].props.disabled = false
      }
    }
  },
  {
    label: "持卡人姓名",
    value: '',
    upKey: 'name',
    rule: [{ required: true, message: '请输入持卡人姓名', trigger: 'change' }],
    props: { clearable : true, disabled: false }
  },
])
let currentModifyRow: any = {}
const modifyHandle = (row: any) => {
  if(row.purpose !== '尽孝金卡'){
    currentModifyRow = row
    modifyConfig.value[4].rule[0].required = false
    modifyConfig.value[4].props.disabled = true
  } else {
    modifyConfig.value[4].rule[0].required = true
    modifyConfig.value[4].props.disabled = false
  }

  MI_modifyForm(row, modifyConfig, modifyFg, async(params: any) => {
    // 如果没有填写支行，弹框提示
    if(!params.location){
      await ElMessageBox.confirm(
        '开户行信息在银行APP里面可以查到。若未填写，可能银行付款会退回。',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
    }
    await usersBank_cardsModifyApi({
      ...row,
      ...params,
      name: params.purpose === '尽孝金卡' ? params.name : '',
    })
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}
// 确认后修改
let modifyAfterFg = ref(false)
const modifyAfterConfig: any = ref([
  {
    type: 'SELECT',
    label: '银行简称',
    value: '',
    upKey: 'bankId',
    selectFunc: bankListApi,
    options: [],
    rule: [{ required: true, message: '请选择银行', trigger: 'change' }],
    props: { clearable: true, placeholder: '请选择银行', },
    seleProps: { 
      label: 'alias',
      valueName: 'id',
    }
  },
  {
    label: '开户行信息',
    value: '',
    upKey: 'location',
    props: {clearable: true, placeholder: '请输入开户行信息'},
  },
  {
    type: 'SELECT',
    label: '卡用途',
    value: '',
    upKey: 'purpose',
    rule: [{ required: true, message: '请选择卡用途', trigger: 'change' }],
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '奖金卡', id: '奖金卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡用途'},
    seleProps: {},
    selectCb: (value: string) => {
      if(value !== '尽孝金卡'){
        modifyCardEle.value.dataObj.name = ''
        modifyAfterConfig.value[3].rule[0].required = false
        modifyAfterConfig.value[3].props.disabled = true
      } else {
        // 如果修改前是尽孝金卡
        if(currentModifyRow.purpose === '尽孝金卡'){
          modifyCardEle.value.dataObj.name = currentModifyRow.name
        } else {
          modifyCardEle.value.dataObj.name = ''
        }
        modifyAfterConfig.value[3].rule[0].required = true
        modifyAfterConfig.value[3].props.disabled = false
      }
    }
  },
  {
    label: "持卡人姓名",
    value: '',
    upKey: 'name',
    rule: [{ required: true, message: '请输入持卡人姓名', trigger: 'change' }],
    props: { clearable : true, disabled: false }
  },
])
const modifyAfterHandle = (row: any) => {
  if(row.purpose !== '尽孝金卡'){
    currentModifyRow = row
    modifyAfterConfig.value[3].rule[0].required = false
    modifyAfterConfig.value[3].props.disabled = true
  } else {
    modifyAfterConfig.value[3].rule[0].required = true
    modifyAfterConfig.value[3].props.disabled = false
  }
  MI_modifyForm(row, modifyAfterConfig, modifyAfterFg, async (params: any) => {
    await usersBank_cardsModifyApi({
      ...row,
      ...params,
      name: params.purpose === '尽孝金卡' ? params.name : '',
    })
    ElMessage.success('修改成功')
    modifyAfterFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    '使用前可以删除，一旦使用就不能够删除，是否删除？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return bank_cardsDelApi({id: row.id})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('删除成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })

}

// 确认
const confirmHamdle = (row: any) => {
  ElMessageBox.confirm(
    '是否确认银行卡：' + row.account + '?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return batchConfirmApi({ids: [row.id]})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('确认成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })
}

// 判断是否是最后一张非尽孝金卡
let lastCard = computed(() => {
  return MI_tableData.value.filter(_card => {
    return _card.purpose !== '尽孝金卡' && _card.purpose !== '' && _card.deleted === true
  })
})

// 单个银行卡使用状态改变（switch开关改变）
const singleLockedChange = async (_locked: boolean, row: any) => {
  console.log(lastCard.value)
  // 判断停用的卡，是否为最后一张启用银行卡（不包括尽孝金卡）
  if(_locked === false && lastCard.value.length === 1){
    try {
      await ElMessageBox.confirm(
        // '这是您最后一张银行卡，如果停用，可能工资、奖金、及报销的支付，不能及时到账，是否停工？',
        '系统支持多张银行卡。作废的目的在于卡丢失，或者已经去银行注销了卡。若未注销，请不要作废。请确认是否作废本卡?',
        '提示',
        {
          confirmButtonText: '确认作废',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
    } catch (error) {
      row.deleted = !_locked
      return
    }
  }
  MI_identify.value = true
  convertApi({id: row.id, deleted: _locked}).then(rep => {
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
    fetchData(MI_params)
  })
}

// 设置比例
const sectionalConfig = ref([
  {
    type: 'NUMBER',
    label: '比例',
    value: undefined,
    upKey: 'ratio',
    rule: [{ required: true, message: '请输入比例', trigger: 'change' }],
    props: {max: 100, min: 0, precision: 0, clearable: true, placeholder: '请输入比例'},
  },
])
const sectionalFg = ref<boolean>(false)
let currentRatioRow: any = {}
const proportionHandle = (row: any) => {
  currentRatioRow = row
  MI_modifyForm(row, sectionalConfig, sectionalFg, async(params: any) => {
    await setRatioApi({id: row.id, ...params})
    ElMessage.success('成功')
    sectionalFg.value = false
    fetchData(MI_params)
  })
}

const cancelRow = async (row: any) => {
  await setRatioApi({id: row.id, ratio: null} as any)
  ElMessage.success('成功')
    sectionalFg.value = false
    fetchData(MI_params)
}


// ------格式化银行卡号
const bankCardFormat = (cardNumber: any) => {
  if(!cardNumber){
    return ''
  }
  // 移除所有非数字字符
  const cleanedNumber = (cardNumber + '').replace(/\D/g, '');
  // 将数字按每4位分组，使用空格隔开
  const formattedNumber = cleanedNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  return formattedNumber;
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addCardHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      icon: "Refresh",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "持卡人",
          prop: "name",
          "show-overflow-tooltip": "",
          width: "135"
        }),
        _createVNode(_component_el_table_column, {
          label: "银行简称",
          width: "100",
          prop: "bankAlias",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "银行卡号",
          width: "210",
          prop: "account",
          "show-overflow-tooltip": "",
          formatter: (row) => bankCardFormat(row.account)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "开户行信息",
          width: "155",
          prop: "location",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "卡类型",
          prop: "purpose",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "确认状态",
          prop: "status",
          width: "100",
          "show-overflow-tooltip": "",
          formatter: (row) => row.status === false ? '待确认': '已确认'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "新增日期",
          width: "130",
          prop: "createdAt",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "支付比例",
          width: "180",
          prop: "ratio",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                (row.status === false)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (confirmHamdle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.status === false)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      type: "primary",
                      onClick: ($event: any) => (modifyHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.status === true)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 2,
                      type: "primary",
                      onClick: ($event: any) => (modifyAfterHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (proportionHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (cancelRow(row)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (singleLockedChange(false, row)),
                  disabled: row.deleted === false
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row)),
                  disabled: row.locked === true
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "作废日期",
          width: "180",
          prop: "obsoleteAt",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addFg).value = $event)),
      title: "新增银行卡"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "开户行信息:表示哪个支行办的，比如一张招商银行，在xx支行办理的，就填写 招商银行xx支行",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "addCardEle",
              ref: addCardEle
            }, {
        searchConfig: _unref(addConfig),
        submitText: '确定'
        }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modifyFg).value = $event)),
      title: "修改银行卡"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "开户行信息:表示哪个支行办的，比如一张招商银行，在xx支行办理的，就填写 招商银行xx支行",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "modifyCardEle",
              ref: modifyCardEle
            }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(modifyAfterFg),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(modifyAfterFg) ? (modifyAfterFg).value = $event : modifyAfterFg = $event)),
      title: "修改银行卡"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "开户行信息:表示哪个支行办的，比如一张招商银行，在xx支行办理的，就填写 招商银行xx支行",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (_unref(modifyAfterFg))
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "modifyCardEle",
              ref: modifyCardEle
            }, {
          searchConfig: modifyAfterConfig.value,
          submitText: '确定'
        }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "设置银行卡比例",
      modelValue: sectionalFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sectionalFg).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "比例数值最大为100",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (sectionalFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: sectionalConfig.value,
          submitText: '确定'
        })), {
              btnGroup: _withCtx(() => []),
              _: 1
            }, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})